export default {
  '_b._qhyy': '切換語言',

  '_a._jzz': '載入中...',
  '_a._jzgd': '載入更多',
  '_a._wct': '歡迎來到',
  '_a._gd': '更多',
  '_a._bf': '播放',
  '_a._bcz': '儲存中...',
  '_a._sctp': '上傳圖片',

  '_dl._qssyx': '請輸入信箱',
  '_dl._qssmm': '請輸入密碼',
  '_dl._ann': '登入',
  '_dl._hmyzh': '你沒有帳號?',
  '_dl._qzc': '去註冊',
  '_dl._yzhl': '你有帳號?',
  '_dl._qdl': '去登入',
  '_dl._srqrmm': '請輸入確認密碼',
  '_dl._sryqm': '請輸入邀請碼',
  '_dl._sryzm': '請輸入驗證碼',
  '_dl._ljzc': '立即註冊',
  '_dl._zcbsty': '註冊則表示已閱讀並同意',
  '_dl._yszc': '《隱私政策》',
  '_dl._lcmmbyy': '兩次輸入的密碼不一致',

  '_yzm._fsyzm': '發送驗證碼',
  '_yzm._cxfs': '({time}) 重發',
  '_yzm._fsz': '發送中...',
  '_yzm._fscg': '發送成功',

  '_h._zrm': '最熱門',
  '_h._zxd': '最新的',
  '_h._phb': '排行',
  '_h._qz': '牆紙',
  '_h._ssww': '搜尋',
  '_h._lsjl': '歷史記錄',
  '_h._gd': '更多',
  '_h._dl': '登入',
  '_h._ye': '餘額',
  '_h._dj': '凍結',
  '_h._ybp': '儀表板',
  '_h._wdqb': '我的錢包',
  '_h._scjl': '收藏記錄',
  '_h._xxzx': '訊息中心',
  '_h._fxhy': '分享好友',
  '_h._bzzx': '幫助中心',
  '_h._ggtf': '廣告投放',
  '_h._bqtz': '版權投資',
  '_h._sz': '設定',

  '_sy._jx': '精選',
  '_sy._xpfb': '新品發佈',
  '_sy._gdsp': '更多影片',

  '_qz._jbqz': '精美牆紙收藏',
  '_qz._ssqz': '搜尋牆紙',
  '_qz._qb': '全部',
  '_qz._zrfg': '自然風光',
  '_qz._cxys': '抽象藝術',
  '_qz._csjz': '城市建築',
  '_qz._dmyx': '動漫遊戲',
  '_qz._yzxk': '宇宙星空',
  '_qz._yl': '預覽',
  '_qz._xzqz': '下載牆紙',
  '_qz._fbl': '解析度',
  '_qz._fl': '分類',
  '_qz._jzz': '載入中',
  '_qz._myzdpp': '沒有找到匹配的牆紙',

  '_sp._xyjscl': '需要解鎖才能觀看',
  '_sp._cz': '儲值',
  '_sp._jsqj': '解鎖全集',
  '_sp._jsbj': '解鎖本集',
  '_sp._sc': '收藏',
  '_sp._fx': '分享',
  '_sp._jsqjjs': '確認支付{a}並解鎖全集嗎?',
  '_sp._jsbjjs': '確認支付{a}並解鎖全集嗎?',
  '_sp._zfz': '支付中...',
  '_sp._qrzf': '確認支付',
  '_sp._qx': '取消',

  '_qz._smrc': '山脈日出',
  '_qz._cxjh': '抽象幾何',
  '_qz._dsyj': '都市夜景',
  '_qz._dmfj': '動漫風景',
  '_qz._hhxk': '浩瀚星空',
  '_qz._slmw': '森林迷霧',
  '_qz._scld': '色彩流動',
  '_qz._xdjz': '現代建築',

  '_qb._cbjl': '存幣記錄',
  '_qb._jyjl': '交易記錄',
  '_qb._bddz': '綁定地址',
  '_qb._txjl': '提現記錄',

  '_m._tcdl': '登出',
  '_m._cb': '存幣',
  '_m._tb': '提幣',

  '_cb._ssdz': '搜尋幣種或地址',
  '_cb._bz': '幣種',
  '_cb._je': '金額',
  '_cb._dz': '地址',
  '_cb._sj': '時間',
  '_cb._cz': '操作',
  '_cb._zwjl': '暫無交易記錄',
  '_cb._dny': '第{a}頁,共{b}頁',
  '_cb._jyxq': '交易詳情',
  '_cb._jydz': '交易地址',
  '_cb._zt': '狀態',
  '_cb._yqr': '已確認',
  '_cb._qb': '全部',
  '_cb._jt': '今天',
  '_cb._j7t': '近7天',
  '_cb._j30t': '近30天',
  '_cb._zw': '暫無',
  '_cb._fzcg': '地址已複製到剪貼簿',

  '_jyjl._ssdz': '搜尋幣種或地址',
  '_jyjl._lx': '類型',
  '_jyjl._je': '金額',
  '_jyjl._ye': '餘額',
  '_jyjl._dj': '凍結',
  '_jyjl._sj': '時間',
  '_jyjl._cz': '操作',
  '_jyjl._zwjyjl': '暫無交易記錄',
  '_jyjl._czsx': '重設篩選',
  '_jyjl._dny': '第{a}頁,共{b}頁',
  '_jyjl._jyxq': '交易詳情',
  '_jyjl._jylx': '交易類型',
  '_jyjl._jyje': '交易金額',
  '_jyjl._jyhye': '交易後餘額',
  '_jyjl._djye': '凍結金額',
  '_jyjl._jysj': '交易時間',
  '_jyjl._jyzt': '交易狀態',
  '_jyjl._ywc': '已完成',
  '_jyjl._qb': '全部',
  '_jyjl._jt': '今天',
  '_jyjl._j7t': '近7天',
  '_jyjl._j30t': '近30天',

  '_jyjl._tp1': '存幣',
  '_jyjl._tp2': '提幣',
  '_jyjl._tp3': '支付',
  '_jyjl._tp4': '存幣',
  '_jyjl._tp5': '凍結',
  '_jyjl._tp6': '收益',
  '_jyjl._tp7': '邀請獎勵',
  '_jyjl._tp8': '登入獎勵',
  '_jyjl._tp9': '推廣收益',
  '_jyjl._tp10': '看影片獎勵',
  '_jyjl._tp11': '註冊禮金',
  '_jyjl._tp12': '提現駁回',
  '_jyjl._tp13': '訊息紅包',
  '_jyjl._tp14': '內部劃轉',

  '_cb._shz': '審核中',
  '_cb._yyg': '已通過',
  '_cb._ybh': '已駁回',

  '_bddz._tjdz': '新增地址',
  '_bddz._ssdz': '搜尋地址',
  '_bddz._bz': '幣種',
  '_bddz._dz': '地址',
  '_bddz._sysj': '使用時間',
  '_bddz._cz': '操作',
  '_bddz._zwjl': '暫無地址記錄',
  '_bddz._dny': '第{a}頁,共{b}頁',
  '_bddz._dzewm': '地址二維碼',
  '_bddz._fzdz': '複製地址',
  '_bddz._dzxq': '地址詳情',
  '_bddz._wl': '網路',
  '_bddz._tjsj': '新增時間',
  '_bddz._bzwa': '備註',
  '_bddz._ntq': '{a}天前',
  '_bddz._nxsq': '{a}小時前',
  '_bddz._nfzq': '{a}分鐘前',
  '_bddz._ngg': '剛剛',
  '_bddz._dzyfz': '地址已複製到剪貼簿',
  '_bddz._scqr': '刪除確認',
  '_bddz._scqrdz': '確定要刪除這個地址嗎？',
  '_bddz._qr': '確定',
  '_bddz._qx': '取消',
  '_bddz._scdzcg': '地址刪除成功',

  '_txjl._ztsx': '狀態篩選',
  '_txjl._qbzt': '全部狀態',
  '_txjl._shz': '審核中',
  '_txjl._ytg': '已通過',
  '_txjl._yjj': '已拒絕',
  '_txjl._ssdz': '搜尋地址或金額',
  '_txjl._bz': '幣種',
  '_txjl._je': '金額',
  '_txjl._dz': '地址',
  '_txjl._zt': '狀態',
  '_txjl._sj': '時間',
  '_txjl._cz': '操作',
  '_txjl._zwjl': '暫無交易記錄',
  '_txjl._czsx': '重設篩選',
  '_txjl._dny': '第{a}頁,共{b}頁',
  '_txjl._jyxq': '交易詳情',
  '_txjl._skdz': '收款地址',
  '_txjl._jysj': '交易時間',
  '_txjl._jyzt': '交易狀態',
  '_txjl._fzdz': '地址已複製到剪貼簿',

  '_cbsq._bz': '幣種',
  '_cbsq._wl': '網路',
  '_cbsq._erwm': '二維碼',
  '_cbsq._fzdz': '複製地址',

  '_txsq._bz': '幣種',
  '_txsq._wl': '網路',
  '_txsq._ye': '餘額',
  '_txsq._sxf': '手續費',
  '_txsq._zxtx': '最小提現',
  '_txsq._txdz': '提現地址',
  '_txsq._qxztxdz': '請選擇提現地址',
  '_txsq._txje': '提現金額',
  '_txsq._qsrtxje': '請輸入提現金額',
  '_txsq._yxyzm': '信箱驗證碼',
  '_txsq._qsryxyzm': '請輸入驗證碼',
  '_txsq._ljtx': '立即提現',

  '_jl._wxhd': '我喜歡的',
  '_jl._lsjl': '歷史記錄',

  '_xx._bt': '訊息中心',
  '_xx._wjl': '無記錄',
  '_xx._zsmyxx': '暫時沒有訊息',
  '_xx._sxxx': '重新整理訊息',
  '_xx._sxcg': '重新整理成功',

  '_fx._fxhy': '分享好友',
  '_fx._smfx': '掃描二維碼分享給好友',
  '_fx._jlsm': '獎勵說明',
  '_fx._jlsm1': '1.您直接邀請的朋友，簡稱1級，您將獲得他收益的{a}%',
  '_fx._jlsm2': '2.您的1級朋友，若他再邀請朋友，簡稱2級，獲得他收益的{a}%',
  '_fx._jlsm3': '3.您的2級朋友，若他再邀請朋友，簡稱3級，獲得他收益的{a}%',
  '_fx._fzlj': '複製連結',

  '_bzzx._bzzx': '幫助中心',
  '_bzzx._rhzczh': '如何註冊帳戶',
  '_bzzx._zclc': '註冊流程',
  '_bzzx._rhzcxyh': '如何註冊新帳戶？',
  '_bzzx._rhzcxyh1': '點擊"註冊"按鈕，輸入您的信箱地址，設定密碼，完成信箱驗證後即可成功註冊帳戶。',
  '_bzzx._rhcz': '如何儲值？',
  '_bzzx._rhcz1': '儲值流程',
  '_bzzx._rhcz2': '儲值詳細說明',
  '_bzzx._rhcz3': '點擊我的錢包，存入，選擇你想存入的加密貨幣，向該地址存入即可',

  '_bzzx._rhjsdj': '如何解鎖短劇',
  '_bzzx._rhjsdj2': '點擊單集解鎖劇情，看更多精彩內容',

  '_bzzx._rhtx': '帳戶如何提現',
  '_bzzx._rhtx1': '1.點選我的錢包，提領位址，新增對應加密貨幣提現位址<br>2.點選提現，選擇對應加密貨幣，選擇已綁定的地址，輸入提現數量,等待到帳即可',

  '_bzzx._qtwt': '其他問題',
  '_bzzx._qtwt1': '如何聯繫客服？',
  '_bzzx._qtwt2': '可透過網站右下角的線上客服、客服信箱或客服專線聯繫我們。',
  '_bzzx._myzdwt': '沒有找到您要的答案？',
  '_bzzx._khjybbzn': '我們的客服團隊很樂意爲您提供進一步的幫助。',
  '_bzzx._lxkf': '聯繫客服',

  '_ggtf._bt1': '廣告投放',
  '_ggtf._splb': '影片列表',
  '_ggtf._wcyd': '我參與的',
  '_ggtf._hdbm': '活動編碼',
  '_ggtf._tian': '天',
  '_ggtf._kssj': '開始時間',
  '_ggtf._jssj': '結束時間',
  '_ggtf._ddvp': '達到VIP{a}級，人均參與{b}次',
  '_ggtf._hdzt': '活動狀態',
  '_ggtf._wks': '未開始',
  '_ggtf._ycy': '已參與',
  '_ggtf._qg': '搶購',
  '_ggtf._mygdl': '沒有更多了',
  '_ggtf._qgrtd': '搶購人數太多,請重試',
  '_ggtf._hdxq': '活動詳情',
  '_ggtf._hdjs': '活動介紹',
  '_ggtf._cyyq': '參與要求',
  '_ggtf._zdtz': '最低投資',
  '_ggtf._vpdj': 'VIP等級',
  '_ggtf._rjcy': '人均參與',
  '_ggtf._gmje': '購買金額',
  '_ggtf._qsrgmje': '請輸入購買金額',
  '_ggtf._qx': '取消',
  '_ggtf._ljcy': '立即參與',
  '_ggtf._ssjymm': '輸入交易密碼',
  '_ggtf._qssjymm': '請輸入交易密碼',
  '_ggtf._ji': '級',
  '_ggtf._ci': '次',
  '_ggtf._zdgm': '最低購買金額',
  '_ggtf._zggm': '最高購買金額',
  '_ggtf._zfz': '支付中...',

  '_wdtg._wjl': '暫無參與記錄',
  '_wdtg._tzje': '投資金額',
  '_wdtg._zsy': '總收益',
  '_wdtg._hdts': '活動天數',
  '_wdtg._cysj': '參與時間',
  '_wdtg._qzf': '去支付',
  '_wdtg._jxz': '進行中',
  '_wdtg._djszje': '待結算總金額',
  '_wdtg._gjb': '共{a}筆',
  '_wdtg._djs': '待結算',
  '_wdtg._zrsy': '昨日收益',
  '_wdtg._dbl': '點播量',
  '_wdtg._bfl': '播放量',
  '_wdtg._wdsy': '我的收益',
  '_wdtg._bqffc': '版權方分成',
  '_wdtg._mr0djs': '结算时间',
  '_wdtg._jrsy': '今日收益',
  '_wdtg._mygd': '沒有更多了',

  '_bqyy._bqyy': '版權合作申請預約',
  '_bqyy._qrbq': '確認版權合作預約申請？',
  '_bqyy._qx': '取消',
  '_bqyy._tjyy': '提交預約',

  '_bqyy._spsq': '影片版權合作申請預約',
  '_bqyy._spsy': '與版權商一起推廣影片，讓影片帶來更多的流量，更多的收益！',
  '_bqyy._ljyy': '立即預約',
  '_bqyy._sphz': '什麼是影片版權合作申請？',
  '_bqyy._sphzsm': '影片版權合作申請是提供影片更多推廣合作共贏。透過申請，您將獲得版權商的認可，並有機會與版權商進行深度合作，獲得更多曝光和收益。',
  '_bqyy._sqhch': '申請版權合作的好處',
  '_bqyy._llfz': '流量扶持',
  '_bqyy._llfzsm': '獲得平臺推廣機會，增加曝光和播放量',
  '_bqyy._sytg': '收益提升',
  '_bqyy._sytgsm': '獲得更高的廣告分成和商業合作機會',
  '_bqyy._yxhz': '優先合作',
  '_bqyy._yxhzsm': '優先參與平臺官方活動與商業合作專案',
  '_bqyy._yytj': '預約條件',
  '_bqyy._sptg': '影片廣告推廣要求',
  '_bqyy._sptgsm': '至少參與1個影片推廣達到平臺標準',
  '_bqyy._yysm': '點擊預約後，我們的工作人員將在3個工作天內與您聯繫',

  '_ybp._wdsy': '我的收益',
  // '_ybp._dqye': '當前餘額',
  '_ybp._jr': '今日',
  '_ybp._jrzsy': '今日總收益',
  '_ybp._ljzsy': '累計總收益',
  '_ybp._tgfh': '推廣分紅',
  '_ybp._ljsy': '累計收益',
  '_ybp._bqsy': '版權收益',
  '_ybp._yqfh': '邀請分紅',
  '_ybp._mrsy': '每日收益',
  '_ybp._tgsy': '推廣收益',

  '_tjdz._tjxd': '新增地址',
  '_tjdz._xzbz': '選擇幣種',
  '_tjdz._qbdz': '錢包地址',
  '_tjdz._srdz': '請輸入錢包地址',
  '_tjdz._qx': '取消',
  '_tjdz._bc': '儲存',

  '_sz._smrz': '實名認證',
  '_sz._rzlx': '認證類型',
  '_sz._sfzzm': '身份正面照',
  '_sz._sfzfm': '身份反面照',
  '_sz._zsxm': '真實姓名',
  '_sz._qsrzsxm': '請輸入真實姓名',
  '_sz._sfzhm': '身份證號碼',
  '_sz._qsrsfzhm': '請輸入身份證號碼',
  '_sz._yyzz': '營業執照',
  '_sz._qymc': '企業名稱',
  '_sz._yyzzh': '營業執照號',
  '_sz._qsrqymc': '請輸入企業名稱',
  '_sz._qsryyzzh': '請輸入營業執照號',
  '_sz._qx': '取消',
  '_sz._tjrz': '提交認證',
  '_sz._zt': '狀態',
  '_sz._gr': '個人',
  '_sz._qy': '企業',
  '_sz._shz': '審核中',
  '_sz._ytg': '已通過',
  '_sz._ybh': '已駁回',

  '_mm._xgmm': '修改密碼',
  '_mm._dqxg': '定期修改密碼保護帳戶安全',
  '_mm._dqmm': '當前密碼',
  '_mm._xmm': '新密碼',
  '_mm._qrxmm': '確認新密碼',
  '_mm._qx': '取消',
  '_mm._qrxg': '確認修改',

  '_jymm._xgjymm': '修改交易密碼',

  '_szzx._sz': '設定',
  '_szzx._yrz': '已認證',
  '_szzx._wrz': '未認證',
  '_szzx._jymm': '交易密碼',
  '_szzx._szjymm': '設定或修改交易密碼',
  '_szzx._tcdl': '登出帳號',
  '_szzx._qdtcdl': '確定要登出帳號嗎?',
  '_szzx._qrtc': '確認登出',
  '_szzx._qx': '取消',

  '_yj._gy': '关于',
  '_yj._lxwm': '联系我们',
  '_yj._yszc': '隐私政策',
  '_yj._yhxy': '用户协议',

  '_cd._gszz': '公司资质',
  '_cd._wmyy': '我們擁有完整的行業資格和認證，為用戶提供合法、安全、高品質的視訊服務',
  '_cd._yyzz': '公司合法經營的有效證明，展示了我們的正規註冊資訊和經營範圍',
  '_cd._yyzz2': '依法取得的公司認證營業執照，確保平台內容合法合規',
  '_bz._lxkf': '点击下方联系客服,客服信箱或客服專線聯繫我們',

  '_sz._bjtx': '編輯',
  '_sz._bjxx': '編輯訊息',
  '_sz._tx': '頭像',
  '_sz._bcun': '保存',

  '_db._zskf': '聯繫客服',
  '_db._zsry': '專屬客服',
  '_db._wdq': '未讀',
  '_db._ydq': '已讀',

  '_sc._sctp': '上傳圖片',
  '_sc._xztp': '選擇圖片',
  '_sc._fstp': '發送圖片',
  '_sc._qx': '取消',
  '_sc._hd': '好的',

  '_zcyl._zcbt': '註冊有禮',
  '_zcyl._djdkhb': '點擊打開紅包',
  '_zcyl._zclj': '註冊禮金',
  '_zcyl._hmyzh': '還沒有帳戶?',
  '_zcyl._qzc': '去註冊',
  '_zcyl._qxdjhb': '請先領取紅包',
  '_zcyl._qwzc': '前往註冊',
  '_zcyl._hbysy': '紅包已經使用',

  '_ggtg._qhz': '去劃轉',
  '_ggtg._dqye': '當前餘額',
  '_ggtg._qcz': '去充值',
  '_ggtg._hzje': '劃轉金額',
  '_ggtg._ljhz': '立即劃轉',
  '_ggtg._yebz': '餘額不足',

  '_sq._bhbt': '已驳回',
  '_sq._bhyy': '驳回原因',

  '_xx._ntq': '{n}天前',
  '_xx._nxsq': '{n}小时前',
  '_xx._nfzq': '{n}分钟前',
  '_xx._nggq': '刚刚',
  '_xx._djckgd': '点击查看更多',

  '_ct._zt': '状态',
  '_ct._ljz': '连接中',
  '_ct._ylj': '已连接',
  '_ct._ltlieb': '聊天列表',
  '_ct._bnhzj': '不能和自己聊天',
  '_ct._cylb': '成员列表',

  '_hb._fhb': '紅包',
  '_hb._dqye': '當前餘額',
  '_hb._fsd': '发送到',
  '_hb._hbje': '紅包金額',
  '_hb._qshuru': '請輸入紅包金額',
  '_hb._ljfs': '立即發送',
  '_hb._hbz': '紅包祝福語',
  '_hb._qshuruzhu': '請輸入祝福語',

  '_sp._cuow': '需要先解鎖1-10集才能觀看',

  '_bq._tzzq': '投資週期',
  '_bq._zrsy': '昨日收益',
  '_bq._bqtz': '版權投資',
  '_bq._tzdj': '投資金額',
  '_bq._zfjz': '必須在24小時內支付，否則視為放棄!',
  '_bq._qzf': '去支付',
  '_bq.jz': '截止',
  '_bq._ljzf': '立即支付',
  '_bq._sqbz': '申請備註(可选)',
  '_bq._sqbzsm': '請輸入申請備註',
  '_bq._zzsqz': '申请版权中,等待审核...',

  '_bq._bzr': '比昨日',

  '_app._xz': '下載ReelShortBiz應用程式',
  '_app._smerm': '掃描二維碼下載',
  '_app._xzbt': '下載APP',

  '_m._yhzz': '銀行轉帳',
  '_m._yhxx': '銀行信息',
  '_m._yhmz': '银行名稱',
  '_m._yhdz': '银行地址',
  '_m._yhmc': '姓名',
  '_m._yhzh': '帳號',
  '_m._yhlx': '類型',
  '_m._yhly': '路由',
  '_m._yhdm': '代碼',
  '_m._yhbz': '备注',
  '_m._fzxx': '複製信息',

  '_m._zts': '提示',
  '_m._zyd1': '1.轉帳時請仔細核對收款人姓名、帳號及銀行代碼，任一錯誤均可能導致匯款遺失',
  '_m._zyd2': '2.建議選擇"匯款人承擔全部費用",避免因中轉行扣費導致收款金額不足',
  '_m._zyd3': '3.轉帳通常需1-3個工作天,請耐心等待,如有任何問題請聯絡客服',
  '_m._zyd4': '4.如果有其他問題，請聯絡客服',

  '_m._jyh': '交易號',
  '_m._jyje': '金額',

  '_sp._dbye': '点播余额',
  '_sp.hzye': '划转',
  '_sp._txje': '划转金额',
  '_sp._qsrtxje': '请输入划转金额',
  '_sp._ljhz': '立即划转',
  '_sp._yebz': '余额不足',
  '_sp._qshuru': '请输入正确的转账金额',
  '_sp._fanh': '返回',

  '_sp._tliu': '投放廣告',
  '_sp._xzgj': '選擇國家',
  '_sp._cdcw': '視頻編碼錯誤',
  '_ggtf._hot': '熱門',
  '_tl._tlsj': '投放時間',
  '_tl._xzxb': '選擇性別',
  '_tl._nan': '男',
  '_tl._nv': '女',
  '_tl._hunhe': '混合',
  '_tl._xznl': '選擇年齡',
  '_sp._us': '美國',
  '_sp._en': '英國',
  '_sp._jp': '日本',
  '_sp._fr': '法國',
  '_sp._kr': '南韓',
  '_sp._de': '德國',
  '_sp._id': '印度',
  '_sp._in': '印尼',
  '_sp._au': '澳洲',
  '_sp._es': '西班牙',
  '_sp._my': '馬來西亞',
  '_sp._cn': '中國',
  '_ggtf._fanhui': '返回',
  '_ggtf._jymmts': '請確認交易金額無誤後輸入密碼',
  '_wdtg._wjl_desc': '您還沒有參與任何廣告投放活動',
  '_wd._jxz': '進行中',
  '_wd._djs': '待結算',
  '_wd._ywc': '已完成',
  '_wd._jz': '緊急',
  '_wd._hz': '劃轉',

  '_tl._tlfbqk': '投放資金分佈情況',
  '_tl._tlfbqk_desc': '1-5天:5%(冷啟動期)、6-10天:20%(內容驗證期)、11-15天:40%(IP塑造期)、16-20:35%(短劇矩陣期)',

  // 二期2新增
  '_nhz._sm': '轉帳後金額將轉入影片錢包，用於解鎖影片內容',
  '_nhz._zhzz': '轉帳中...',
  '_nhz._zzcg': '轉帳成功',
  '_nhz._zhzsb': '轉帳失敗，請重試',
  '_m._fzcg': '複製成功',
  '_m._fzsb': '複製失敗，請手動複製',
  '_m._zwfzxx': '暫無資訊可複製',
  '_tx._qb': '全部',
  'activity.detail': '活動詳情',
  'activity.noDesc': '暫無活動介紹',
  'activity.desc': '活動介紹',
  'activity.requirements': '參與要求',
  'activity.minInvest': '最低投資',
  'activity.vipLevel': 'VIP等級',
  'activity.avgParticipation': '人均參與',
  'activity.avgParticipationDesc': '次',
  'activity.country': '選擇國家',
  'activity.deliveryTime': '投放時間',
  'activity.deliveryTimeDesc': '天',
  'activity.gender': '選擇性別',
  'activity.male': '男',
  'activity.female': '女',
  'activity.mixed': '混合',
  'activity.age': '選擇年齡',
  'activity.amount': '購買金額',
  'activity.back': '返回',
  'activity.join': '立即參與',
  emptyData: '暫無資料',
  emptyDataDesc: '暫無參與的廣告活動',
  completedtlement: '已過時',
  preheat: '預熱中',
  progress: '進行中',
  settlement: '待結算',
  transfered: '已劃轉',
  completed: '已完成',
  activityCode: '活動編碼',
  touzAmount: '投資金額',
  activityDays: '活動天數',
  joinTime: '參與時間',
  playSource: '播放來源分佈',
  allPlatforms: '全部平台',
  other: '其他',
  totalPlayNum: '總播放量',
  incomeSummary: '收益總結',
  totalPay: '支付版權費',
  totalIncome: '總收入',
  copyrightRatio: '版權分成',
  promotionIncome: '推廣收益',
  copyrightIncome: '版權分成',
  playNum: '播放量',
  buyNum: '點播量',
  incomeRate: '分成比例',
  yjIncome: '預估收入',
  paid: '已支付',
  timeout: '已超時',
  transfer: '立即劃轉',
  loading: '載入中...',
  loadMore: '載入更多',
  noMore: '沒有更多了',
  nightTime: '凌晨時段',
  morningTime: '上午時段',
  afternoonTime: '下午時段',
  eveningTime: '晚間時段',
  '_h._tc': '登出',
  periodPayment: '時段支付',
  periodPaymentDesc: '每日分4個時段結算，您可按時段支付版權費用',
  day: '天',
  '_dl._hy': '歡迎回來',
  '_dl._cj': '創建帳號',
  '_dl._zmm': '重置密碼',
  '_dl._hyDesc': '登錄您的帳號，繼續探索精彩內容',
  '_dl._cjDesc': '加入 ReelShortBiz，開啟精彩之旅',
  '_dl._zmmDesc': '輸入您的郵箱，我們將發送重置驗證碼',
  '_dl._hlgqsp': '海量高清影視資源',
  '_dl._gxhty': '個性化推薦算法',
  '_dl._ffddsp': '豐富的短視頻',
  '_dl._dlzh': '登錄帳號',
  '_dl._sdndyx': '輸入您的郵箱和密碼繼續',
  '_dl._email': '郵箱地址',
  '_dl._qsryx': '請輸入您的郵箱地址',
  '_dl._dlmm': '密碼',
  '_dl._qsrmm': '請輸入您的密碼',
  '_dl._wjmm': '忘記密碼？',
  '_dl._immdl': '立即登錄',
  '_dl._hmyzh2': '還沒有帳號？',
  '_dl._ljzc2': '立即註冊',
  '_dl._cjzh': '創建帳號',
  '_dl._jswmd': '加入 ReelShortBiz，開啟精彩之旅',
  '_zh._qszmm': '請設置您的密碼',
  '_zh._qrmm': '確認密碼',
  '_zh._qmm': '請再次輸入密碼',
  '_zc._yqm': '邀請碼',
  '_zc._sryqm': '請輸入邀請碼',
  '_dl._yzm': '驗證碼',
  '_dl._qsryzm': '請輸入驗證碼',
  '_dl._yjyzh': '已有帳號？',
  '_dl._zcbsty2': '註冊即代表同意',
  '_dl._zcbstyDesc': '隱私政策',
  '_dl._newmm': '新密碼',
  '_dl._qszxmm': '請設置新密碼',
  '_dl._qrmm': '確認密碼',
  '_dl._qzcsrmm': '請再次輸入新密碼',
  '_dl._czmm': '重置密碼',
  '_dl._xqlmm': '想起了密碼？',
  '_dl._fhdl': '返回登錄',
  '_dl._srdllmmbyz': '兩次密碼輸入不一致',
  '_dl._czcg': '密碼重置成功',
  '_h._zc': '註冊',
  // '_ybp._wdsy': '我的收益',
  '_ybp._jrsy': '今日收益',
  '_ybp._jztr': '較昨日',
  '_ybp._bfl': '播放量',
  '_ybp._dbl': '點播量',
  '_ybp._syqs': '收益趨勢',
  // '_ybp._jr': '今日',
  '_ybp._t': '天',
  '_ybp._dqye': '賬戶餘額',
  '_ybp._djs': '待結算',
  '_ybp._zhl': '轉化率',
  '_ybp._sjgl': '數據概覽',
  '_ybp._zrsy': '昨日收益',
  '_ybp._bysy': '本月收益',
  '_ybp._yysj': '運營數據',
  '_ybp._zr': '昨日',
  '_ybp._zjfrs': '總付費人數',
  '_ybp._mtdqje': '明天到賬金額',
  '_ybp._jsy': '淨收益',
  '_ybp._bqfy': '版權費用支付計劃',
  '_ybp._yzf': '已支付',
  '_ybp._qzf': '去支付',
  '_ybp._bqfyts': '版權費用支付後，將優先保障您的收益和權益。',
  '_ybp._syjl': '收益記錄',
  '_ybp._ckgd': '查看更多',
  '_ybp._ssdt': '實時動態',
  '_ybp._bzzx': '幫助中心',
  '_ybp._lxkf': '聯繫客服',
  '_ybp._zrxz': '昨日收益',
  '_ybp._zdsy': '總收益',
  '_ybp._qygy': '上個月',
  '_ybp._jsjl': '結算記錄',
  '_ybp._hzjl': '劃轉記錄',
  '_ybp._jfzq': '分鐘前',
  '_ybp._fzq': '小時前',

  '_ybp._djs_mt': '明日結算金額',

  '_yj._rule': '平台規則',

  '_bq._jjks': '即時開始',
  '_bq._jxz': '進行中',
  '_bq._jks': '距開始',
  '_bq._jjs': '距結束',
  '_bq._t': '天',
  '_bq._h': '時',
  '_bq._m': '分',
  '_bq._s': '秒',
  '_bq._kssj': '開始時間',
  '_bq._jssj': '結束時間',
  '_bqq._tzdj': '投资单价',
  '_bqq._hdts': '活動天數',
  '_bqq._vip': 'VIP級別',
  '_bqq._rjcy': '人均参与',
  '_bqq._cs': '次',
  '_bqq._ysjd': '已售进度',
  '_bqq._ljqg': '立即抢购',
  '_bqq._zbkqg': '暂不可购',
  '_bqq._jzz': '加载中',
  '_bqq._jzgd': '加载更多',
  '_bqq._wz': '没有更多了',

  '_sp._gdsj': '共{n}集',
  '_sy._jl': '待結算記錄',
  '_ybp._zsy': '總收益',
  '_ybp._djsjl': '待結算記錄',
  '_ybp._bqbm': '編碼',
  '_ybp._je': '金額',
  '_ybp._sj': '時間',
  '_sy._djs': '待結算',
  '_sy._yjs': '已結算',
  '_sy._gdstjl': '共{n}條記錄',
  '_sy._gjd': '共{n}條',

  '_sp.tgdy': '金额不能低于{a}',
  '_sp.tggy': '金额不能高于{a}',

  '_tg._zdyje': '自訂金額'
}
